import type { GooglePlace } from "@albertine/types";
import type { ThemeLocation } from "@albertine/types/theme";
import { addressComponentsToObject } from "../CatalogItem";
import { toAddressComponents } from "./google/GooglePlaceService";
import { isEmpty } from "./string.util";

export function placeToLocation(place: GooglePlace): ThemeLocation | null {
    const addressComponents = toAddressComponents(place.addressComponents);
    const openSearchLocation = addressComponentsToObject(addressComponents);

    const country = place.addressComponents?.find((it) =>
        it.types?.includes("country"),
    )?.longText;

    const countryCode = place.addressComponents?.find((it) =>
        it.types?.includes("country"),
    )?.shortText;

    if (!country || !countryCode) {
        return null;
    }

    const city =
        openSearchLocation && !isEmpty(openSearchLocation.locality)
            ? openSearchLocation.locality || null
            : null;

    return {
        city,
        country,
        countryCode,
    };
}
